import { HttpTypes } from "@medusajs/types"

export type StockReading = {
  /** null when Unleashed doesn't stock-track the line — say nothing rather than "sold out". */
  label: string | null
  tone: "ok" | "low" | "out"
  available: number
}

/** Plenty above this many units; below it we always show the number (Jayson: never "precise but wrong"). */
const PLENTY = 20

/**
 * Availability for one variant, from the Unleashed stock synced into Medusa.
 * allow_backorder means the supplier can fulfil it (e.g. Teelixir can make more) — that's shown
 * as In stock, not "on backorder", since the row is genuinely orderable, not waiting on anything.
 * Only a variant with allow_backorder:false and no stock left (e.g. Teelixir blocked by empty
 * tubes/sachets, nothing left on the shelf) is genuinely unavailable.
 */
export const variantStock = (variant: HttpTypes.StoreProductVariant): StockReading => {
  if ((variant as any).manage_inventory === false) return { label: null, tone: "ok", available: 0 }
  const available = Number((variant as any).inventory_quantity ?? 0)
  if (available <= 0) {
    return (variant as any).allow_backorder
      ? { label: "In stock", tone: "ok", available: 0 }
      : { label: "Currently unavailable", tone: "out", available: 0 }
  }
  if (available < PLENTY) return { label: `Only ${available} left`, tone: "low", available }
  return { label: "In stock", tone: "ok", available }
}

export const stockClass = (tone: StockReading["tone"]) =>
  tone === "out" ? "text-red-600" : tone === "low" ? "text-elevate-gold-dark" : "text-elevate-grey-mid"
